import React, { useContext, useState } from 'react';
import { Container, Form, Row, Col, Navbar, Button } from 'react-bootstrap';
import styled from 'styled-components';
import { OptionContext } from '../../contexts/OptionContext';
import Avatar from '../Global/Avatar';
import Switch from '../Global/Switch';
import RobotBox from '../layout/RobotBox';

const nextDefault = () => { };

const SwitchCustom = styled(Switch)``;

const MessageTip = styled.div`

    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 6px 16px #00000029;
    border-radius: 10px;
    font-size: 0.7615rem;
    color: black;
    text-align: center;
    min-height: 100px;
`;

const SeletorProjetoInput = ({ next = nextDefault }) => {
  const context = useContext(OptionContext);
  const { dialog, input } = context;
  const [ranges, setRanges] = useState({
    quality: {
      text: 'Alta qualidade',
      value: true,
      index: 0,
    },
    time: {
      text: 'Resultado rápido',
      value: true,
      index: 0,
    },
    price: {
      text: 'Custo baixo',
      value: false,
      index: 0,
    },
  });
  const [message, setMessage] = useState('Soluções com alta qualidade e com prazo curto normalmente são bem remuneradas.');

  const updateMessage = (updatedRanges) => {
    if (updatedRanges.quality.value && updatedRanges.time.value) {
      setMessage('Soluções com alta qualidade e com prazo curto normalmente são bem remuneradas.');
    }
    if (updatedRanges.quality.value && updatedRanges.price.value) {
      setMessage('Soluções com alta qualidade e custo baixo não podem ser rápidas.');
    }
    if (updatedRanges.price.value && updatedRanges.time.value) {
      setMessage('Soluções rápidas e com custo baixo normalmente não carregam tanta qualidade.');
    }
  };

  const handleChange = (value, key) => {
    Object.keys(ranges).forEach((rangeKey) => {
      if (rangeKey === key) {
        ranges[key].value = value;
        if (value) {
          ranges[key].index = 0;
        } else {
          ranges[key].index = 2;
        }
      } else {
        ranges[rangeKey].index += 1;
      }
    });

    const lengthTrue = Object.keys(ranges).filter((obj) => ranges[obj].value).length;

    if (lengthTrue > 2) {
      let maxIndex = -1;
      let maxIndexKey = '';

      Object.keys(ranges).forEach((rangeKey) => {
        if (ranges[rangeKey].index > maxIndex) {
          maxIndex = ranges[rangeKey].index;
          maxIndexKey = rangeKey;
        }
      });

      ranges[maxIndexKey].value = false;
    }

    setRanges({ ...ranges });
    updateMessage(ranges);
  };

  const continueAction = () => {
    next(Object.keys(ranges).filter((obj) => ranges[obj].value));
  };

  return (
    <Container>
      <Row className="my-4 my-md-5 mx-md-4 mx-lg-7">
        <Col xs="12" md="4">
          <Form>
            {
              Object.keys(ranges).map((range) => (
                <Form.Group controlId="formBasicSwitch" key={range}>
                  <SwitchCustom
                    id={`switch-group-${range}`}
                    label={ranges[range].text}
                    value={ranges[range].value}
                    onChange={(value) => handleChange(value, range)}
                  />
                </Form.Group>
              ))
            }
          </Form>
        </Col>
        <Col xs="12" md="8" lg="6">
          <MessageTip className="p-5">
            <Row>
              <Avatar
                src={dialog.botAvatar}
                rounded
                size="sm"
              />
              <Col xs="10" className="mr-auto px-4">
                {message}
              </Col>
            </Row>

          </MessageTip>
        </Col>

      </Row>
      <div className="fixed-bottom mb-xl-4">
        <Container fluid="lg">
          <RobotBox background={input.background} className="px-4 py-3 py-md-4 py-lg-6 justify-content-center align-items-center">
            <Col xs={12} md="4">
              <Button size="md" block className="px-0 px-lg-5 py-3 btn-min-lg" variant="purple" onClick={continueAction}>
                Continuar
              </Button>
            </Col>
          </RobotBox>
        </Container>
      </div>
    </Container>
  );
};

export default SeletorProjetoInput;
